// Browser must support both:
//   1. Basic WebAssembly compile/instantiate (any WASM-capable browser since 2017).
//   2. WebAssembly reference types (the `externref` value type, 0x6F),
//      which `wasm-bindgen` emits by default and our core binary requires.
//      Reference types shipped in Chrome 96 (Dec 2021), Firefox 102 (Jun 2022),
//      and Safari 16 (Sep 2022). Without this second probe, ancient browsers
//      pass the basic check and then crash silently mid-pageload with
//      "CompileError: invalid value type 'externref'", leaving the user with
//      a broken UI and no "browser not supported" page.
//
// Basic-WASM probe based on https://stackoverflow.com/a/47880734/1805218.
// Reference-types probe is a 16-byte module declaring a single immutable
// global of type externref initialized via `ref.null extern`:
//   (module (global externref (ref.null extern)))

const probeBasicWASM = (): boolean => {
  try {
    if (typeof WebAssembly === 'object' && typeof WebAssembly.instantiate === 'function') {
      const module = new WebAssembly.Module(Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00));
      if (module instanceof WebAssembly.Module) {
        return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
      }
    }
  } catch (e) {
    // Fall through to return false.
  }
  return false;
};

const probeReferenceTypes = (): boolean => {
  try {
    // prettier-ignore
    const bytes = Uint8Array.of(
      0x00, 0x61, 0x73, 0x6d, // \0asm magic
      0x01, 0x00, 0x00, 0x00, // version 1
      0x06, 0x06,             // global section, body length 6
      0x01,                   // 1 global
      0x6f, 0x00,             // type externref, immutable
      0xd0, 0x6f, 0x0b,       // init expr: ref.null extern; end
    );
    return new WebAssembly.Module(bytes) instanceof WebAssembly.Module;
  } catch (e) {
    return false;
  }
};

export const isWASMSupported = probeBasicWASM() && probeReferenceTypes();
